import { combineReducers } from 'redux';
import { APIReducer } from 'store/apiReducer';
import {
    CONTEXT_AJOUT_ARME_EN_MASSE_FICHIER_IMPORTE,
    CONTEXT_AJOUT_ARME_EN_MASSE_FICHIERS_IMPORTES,
    CONTEXT_AJOUT_ARME_EN_MASSE_IMPORT,
    CONTEXT_AJOUT_ARME_EN_MASSE_MODELE_INTERNATIONAL,
    CONTEXT_AJOUT_ARME_EN_MASSE_MODELE_NATIONAL,
    CONTEXT_AJOUT_ARME_EN_MASSE_RAPPORT_ERREUR,
    CONTEXT_AJOUT_ARME_EN_MASSE_RAPPORT_SUCCES,
    CONTEXT_GET_EXPORT_REFERENTIEL_PAYS,
} from '../../../constants/apiUrls.constants';

const ajoutArmeEnMasse = combineReducers({
    import: APIReducer.bind(null, CONTEXT_AJOUT_ARME_EN_MASSE_IMPORT),
    fichiersImportes: APIReducer.bind(null, CONTEXT_AJOUT_ARME_EN_MASSE_FICHIERS_IMPORTES),
    fichierRapportErreur: APIReducer.bind(null, CONTEXT_AJOUT_ARME_EN_MASSE_RAPPORT_ERREUR),
    fichierRapportSucces: APIReducer.bind(null, CONTEXT_AJOUT_ARME_EN_MASSE_RAPPORT_SUCCES),
    fichierImporte: APIReducer.bind(null, CONTEXT_AJOUT_ARME_EN_MASSE_FICHIER_IMPORTE),
    modeleNational: APIReducer.bind(null, CONTEXT_AJOUT_ARME_EN_MASSE_MODELE_NATIONAL),
    modeleInternational: APIReducer.bind(null, CONTEXT_AJOUT_ARME_EN_MASSE_MODELE_INTERNATIONAL),
    referentielPays: APIReducer.bind(null, CONTEXT_GET_EXPORT_REFERENTIEL_PAYS),
});

export default ajoutArmeEnMasse;
